import service from './request'

// 本地测试
// const api_url = "http://192.168.7.109:5100"

// 上线
const api_url = "https://nicedream.top"

// 查询广告
export const banner = data => {
  return service({
    url: api_url + "/gw/banner",
    method: 'post',
    data: JSON.stringify(data)
  })
}

// 查询货品
export const  queryprod= data => {
    return service({
      url: api_url + "/gw/query_prod",
      method: 'post',
      data: JSON.stringify(data)
    })
  }


// 查询床褥
export const  queryProdDetail= data => {
    return service({
      url: api_url + "/gw/query_prod_detail",
      method: 'post',
      data: JSON.stringify(data)
    })
  }


// 查询分类
export const  category= data => {
  return service({
    url: api_url + "/gw/query_category",
    method: 'post',
    data: JSON.stringify(data)
  })
}





    

export default {
  banner,
  queryprod,
  queryProdDetail,
  category
}
